var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileVetted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#16d696;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-user-check",
    "data-name": "Icon awesome-user-check",
    className: "cls-1",
    d: "M6.79,6.19a3,3,0,1,0-3-3,3,3,0,0,0,3,3Zm2.09.75H8.49a4.06,4.06,0,0,1-3.41,0H4.69a3.15,3.15,0,0,0-3.14,3.14v1a1.12,1.12,0,0,0,1.12,1.12H10.9A1.12,1.12,0,0,0,12,11.05v-1A3.14,3.14,0,0,0,8.88,6.94Zm7.55-3-.65-.66a.27.27,0,0,0-.39,0h0L12.94,5.71,11.88,4.64a.28.28,0,0,0-.4,0h0l-.65.65a.28.28,0,0,0,0,.39h0l1.9,1.93a.27.27,0,0,0,.39,0h0l3.3-3.28a.29.29,0,0,0,0-.39Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileVetted);
export default __webpack_public_path__ + "static/media/profile-vetted.760758ed58af9903c62b2530da86b1bf.svg";
export { ForwardRef as ReactComponent };